import { combineReducers } from "redux";
import { offers } from "./offers";
import { marketAnalysis } from "./market-analysis";
import { summaryPayment } from "./summary-payment";
import SalesReducer from "./sales";
import { createOffer } from "./create-offer";
import UtilReducer from "./util";
import { PassengersReducer } from "./passengers";
import AdvancedManagementReducer from "./advanced-management";
import AccountLinkReducer from "./account-link";

const reducers = combineReducers({
	offers,
	mySales: SalesReducer,
	createOffer,
	marketAnalysis,
	summaryPayment,
	util: UtilReducer,
	myPassengers: PassengersReducer,
	advancedManagement: AdvancedManagementReducer,
	accountLink: AccountLinkReducer
});

export default reducers;
